import { FuzzySearch } from '@/api/purchaseAndSaleAPI'
import selectOption from '@/store/dict/selectOptionDict'
import commonConfig from '@/baseData/carViolation/recordListUpdate'
import { operateMaxShowLength } from '@/store/dict/config'

/* 车牌号 */
async function getCarList(query, cb) {
  if (query.length >= 4) {
    const { data } = await FuzzySearch({
      plateNo: query,
      state: 1,
    })
    cb && cb(data)
  }
}
export default function () {
  const dealWithSearch = (val) => {
    const params = {}
    const { violationTime } = val
    if (violationTime && violationTime.length > 0) {
      params.fromTime = violationTime[0]
      params.toTime = violationTime[1]
    }
    return { ...params, ...val, customerId: this.customerId, customerType: Number(this.customerType) }
  }
  const { tableData } = commonConfig.call(this, { isIdClick: false })
  const formData = {
    list: [
      {
        el: 'select',
        itemConfig: {
          label: '车牌号',
          prop: 'carId',
        },
        elConfig: {
          filterable: true,
          remote: true,
          'reserve-keyword': true,
          clearable: true,
          placeholder: '请输入',
          'remote-method':
            (query) => {
              getCarList(query, (list) => {
                this.configData.formData.list[0].elConfig.options.list = list
              })
            },
          options: {
            label: 'plateNo',
            value: 'id',
            list: [],
          },
        },
      },
      {
        el: 'date-picker',
        itemConfig: {
          label: '违章时间',
          prop: 'violationTime',
        },
      },
      {
        el: 'select',
        itemConfig: {
          label: '违章处理状态',
          prop: 'handleState',
        },
        elConfig: {
          placeholder: '请选择违章处理状态',
          options: { // 下拉数据
            label: 'label',
            value: 'value',
            list: [
              { value: '', label: '全部' },
              ...this.dictParseList(selectOption.processingstatusDict),
            ],
          },
        },
      },
      {
        el: 'select',
        itemConfig: {
          label: '罚款缴款状态',
          prop: 'paymentState',
        },
        elConfig: {
          placeholder: '请选择罚款缴款状态',
          options: { // 下拉数据
            label: 'label',
            value: 'value',
            list: [
              { value: '', label: '全部' },
              ...this.dictParseList(selectOption.paymentStateList),
            ],
          },
        },
      },
    ],
    formProps: { model: {} },
    dealWithSearch: this.dealWithSearch ? this.dealWithSearch : dealWithSearch,
  }
  const operateColumn = {
    name: 'operate',
    columnProps: {
      prop: 'operate',
      label: '操作',
      fixed: 'right',
      width: 240,
    },
    maxShowLength: operateMaxShowLength,
    type: 'operate',
    getOperateList: ({ row }) => {
      const result = []
      result.push({ name: 'detail', label: '详情', action: () => this.detail(row) })
      return result
    },
  }
  return {
    formData,
    tableData,
    operateColumn,
  }
}
